import { motion } from "framer-motion";

// Reusable scroll-reveal wrapper
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

// Section heading eyebrow
export const Eyebrow = ({ children, testId }) => (
  <div
    data-testid={testId}
    className="inline-flex items-center gap-2 text-[11px] tracking-[0.35em] uppercase text-[#d4af37] mb-6"
  >
    <span className="w-8 h-px bg-[#d4af37]/60" />
    {children}
  </div>
);
